//all form field in one place
//factory form option start

/*
key word to search options
[
  facz->factory,
  usrd->user,
  prodz->product,
  venz->vendor,
  qualz->qulity,
  labrcstz->labourcost,
  subqualz->subquality,
  opez->operator,
  leafWarez->leafwarehouse
  cartz->cartoon type
  plasz->plastic type
  cartstz->cartoon stock
  plaststz->plastic stock
  leafstz->leaf stock

]
use following type value 
-use "text" for text type
-use "file" for file type
-use "password" for password type
-use "email" for email type

*/

export const FormOptionsFactory = [
  //key-facz
  {
    type: "text", //for input type
    labelName: "Factory Name", // for input label
    placeholder: "Enter name", //for placeholder
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text",
    labelName: "Address",
    placeholder: "Enter address",
    isRequired: false,
    valueLabel: "address", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "email",
    labelName: "Email",
    placeholder: "Enter email",
    isRequired: false,
    valueLabel: "email", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Phone",
    placeholder: "Enter phone",
    isRequired: false,
    valueLabel: "phone", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: false,
    valueLabel: "status", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2", //css to adjust two element side by side
  },
];
//factory form option end

//user form option start
export const FormOptionsUser = [
  //key->usrd
  {
    type: "text",
    labelName: "Name",
    placeholder: "Enter name",
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  
  {
    type: "select",
    labelName: "Role",
    placeholder: "Select Role",
    isRequired: true,
    valueLabel: "role", //to select correct value for field
    options: [
      { value: "super_admin", label: "Super Admin", type: "role" },
      { value: "factory_admin", label: "Factory Admin", type: "role" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Factory",
    placeholder: "Select Factory",
    isRequired: true,
    valueLabel: "factory", //to select correct value for field
    options: [
      // { value: "admin", label: "Admin", type: "factory" },
      // { value: "factory_admin", label: "Factory Admin", type: "factory" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "email",
    labelName: "E-mail",
    valueLabel: "email", //to select correct value for field
    placeholder: "Enter email address",
    isRequired: true,
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "password",
    labelName: "Password",
    placeholder: "Enter password",
    isRequired: true,
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,

    valueLabel: "password", //to select correct value for field
  },

  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: true,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//user form option end

//product form option start
export const FormOptionsProducts = [
  //key->prodz
  {
    type: "text",
    labelName: "Name",
    placeholder: "Enter name",
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: true,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Quality",
    placeholder: "Select Quality",
    isRequired: true,
    isAdjust: false,
    valueLabel: "quality", //to select correct value for field
    options: [
      { value: "firstQuality", label: "First Quality", type: "quality" },
      { value: "secondQuality", label: "Second Quality", type: "quality" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "number",
    labelName: "Price(Rs)",
    placeholder: "Enter price",
    isRequired: true,
    isAdjust: false,
    valueLabel: "price", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "number",
    labelName: "Discount amount",
    placeholder: "Discount amount",
    isRequired: false,
    valueLabel: "discount_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !sblock mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    isAdjust: false,
  },

  {
    type: "select",
    labelName: "Discount Type",
    placeholder: "Discount Type",
    isRequired: false,
    repeatType: true, // only make true if there is more option button
    isAdjust: false,
    valueLabel: "discount_type", //to select correct value for field
    options: [
      { value: "flat", label: "Flat", type: "discount_type" },
      { value: "%", label: "%", type: "discount_type" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },

  {
    type: "date",
    labelName: "Effect From",
    placeholder: "Effect From",
    isRequired: false,
    isAdjust: false,
    valueLabel: "effect_from", //to select correct value for field
    // CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "date",
    labelName: "Effect To",
    placeholder: "Effect To",
    isRequired: false,
    isAdjust: false,
    valueLabel: "effect_to", //to select correct value for field
    // CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
  },
];

//product form option end
//vendor form option start

export const FormOptionsVendor = [
  //key->venz
  {
    type: "text",
    labelName: "Name",
    placeholder: "Enter name",
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    isAdjust: false,
  },
  {
    type: "select",
    labelName: "Type",
    placeholder: "Select Type",
    isRequired: true,
    valueLabel: "type", //to select correct value for field
    options: [
      { value: "leaf", label: "Leaf", type: "type" },
      { value: "raw_material", label: "Raw Material", type: "type" },
    ],
    CustomInputStyle: "w-[100%] lg:w-[47%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "text",
    labelName: "Address",
    placeholder: "Enter address",
    isRequired: false,
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
    valueLabel: "address", //to select correct value for field
    CustomInputStyle: "w-[100%] lg:w-[47%]  !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "number",
    labelName: "Contact Number",
    placeholder: "Enter contact number",
    isRequired: false,
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
    valueLabel: "contact_number", //to select correct value for field
    CustomInputStyle: "w-[100%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: true,
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%]  !inline-block mr-2", //css to adjust two element side by side
  },
];
//vendor form option end

//Quality
export const FormOptionsQuality = [
  //key->qualz
  {
    type: "text", //for input type
    labelName: "Name", // for input label
    placeholder: "Enter name", //for placeholder
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: true,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];
//quality end\

//sub quality start
export const FormOptionsSubQuality = [
  //key->subqualz
  {
    type: "text", //for input type
    labelName: "Name", // for input label
    placeholder: "Enter name", //for placeholder
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Quality",
    placeholder: "Select Quality",
    isRequired: true,
    valueLabel: "quality", //to select correct value for field
    options: [
      // { value: "admin", label: "Admin", type: "factory" },
      // { value: "factory_admin", label: "Factory Admin", type: "factory" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: true,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//sub quality end
//LabourCost start
export const FormOptionsLabourCost = [
  //key->labrcstz
  {
    type: "text", //for input type
    labelName: "Job Title", // for input label
    placeholder: "Enter job title", //for placeholder
    isRequired: true,
    valueLabel: "job_title", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Number of Staff",
    placeholder: "Enter no.of staff",
    isRequired: true,
    valueLabel: "no_staff", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Factory",
    placeholder: "Factory",
    isRequired: true,
    valueLabel: "factory", //to select correct value for field
    options: [
      { value: "factory1", label: "Factory 1", type: "factory" },
      { value: "factory2", label: "Factory 2", type: "factory" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "number",
    labelName: "Average Cost",
    placeholder: "Enter average salary",
    isRequired: true,
    valueLabel: "average_salary", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "date",
    labelName: "Effect Date",
    placeholder: "Enter Effect Date",
    isRequired: true,
    valueLabel: "effective_date", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];
////LabourCost  end

//operator form option start
export const FormOptionsOperator = [
  //key->opez
  {
    type: "text",
    labelName: "Name",
    placeholder: "Enter name",
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text",
    labelName: "Address",
    placeholder: "Enter Address",
    isRequired: true,
    valueLabel: "address", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Factory",
    placeholder: "Select Factory",
    isRequired: true,
    valueLabel: "factory", //to select correct value for field
    options: [
      // { value: "admin", label: "Admin", type: "factory" },
      // { value: "factory_admin", label: "Factory Admin", type: "factory" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "number",
    labelName: "Contact Number",
    placeholder: "Contact Number",
    isRequired: true,
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
    valueLabel: "contact_number", //to select correct value for field
  },

  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: true,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//operator form option end

//leafwarehouse form option start
export const FormOptionsLeafWareHouse = [
  //key-leafWarez
  {
    type: "text", //for input type
    labelName: "Name", // for input label
    placeholder: "Enter name", //for placeholder
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text",
    labelName: "Address",
    placeholder: "Enter address",
    isRequired: false,
    valueLabel: "address", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "number",
    labelName: "Phone",
    placeholder: "Enter phone",
    isRequired: true,
    valueLabel: "contact_number", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: true,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//leafwarehouse form option end
//cartoon type form option start
export const FormOptionsCartoonType = [
  //key-cartz
  {
    type: "text", //for input type
    labelName: "Name", // for input label
    placeholder: "Enter name", //for placeholder
    isRequired: true,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text",
    labelName: "Size",
    placeholder: "Enter size",
    isRequired: true,
    valueLabel: "size", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Product",
    placeholder: "Select product",
    isRequired: true,
    valueLabel: "product", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Product Quantity",
    placeholder: "Enter product quantity",
    isRequired: true,
    valueLabel: "product_quantity_per_cartoon", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: false,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//cartoon type form option end
export const FormOptionsPlasticType = [
  //key-plasz
  {
    type: "text", //for input type
    labelName: "Name", // for input label
    placeholder: "Enter name", //for placeholder
    isRequired: true,
    valueLabel: "type", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Product",
    placeholder: "Select product",
    isRequired: true,
    valueLabel: "product", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text", //for input type
    labelName: "Size", // for input label
    placeholder: "Enter size", //for placeholder
    isRequired: false,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Weight Of Plastic Per Pack",
    placeholder: "Enter weight of plastic",
    isRequired: true,
    subField: "Per Pices",
    valueLabel: "weight_of_plastic_per_pack", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "number",
    labelName: "Quantity Per Plastic",
    placeholder: "Enter quantity per plastic",
    isRequired: true,
    valueLabel: "product_quantity_per_plastic", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Weight Of Plastic Per Piece",
    placeholder: "Enter weight of plastic",
    isRequired: true,
    subField: "Per Pices",
    valueLabel: "weight_of_plastic_per_pices", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: true,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];
//plastictype form option end
//production form option start
export const FormOptionsProduction = [
  //key->prodz
  {
    type: "select",
    labelName: "Product",
    placeholder: "Select product",
    isRequired: false,
    valueLabel: "product", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Operator",
    placeholder: "Select operator",
    isRequired: false,
    valueLabel: "operator", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Mold",
    placeholder: "Select mold",
    isRequired: false,
    valueLabel: "mold", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Quality",
    placeholder: "Select quality",
    isRequired: false,
    valueLabel: "quality", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: false,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Quality",
    placeholder: "Select Quality",
    isRequired: false,
    valueLabel: "quality", //to select correct value for field
    options: [
      { value: "firstQuality", label: "First Quality", type: "quality" },
      { value: "secondQuality", label: "Second Quality", type: "quality" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    inAdjust: false, //used only when there is adjusted form, avoid for others
  },
  {
    type: "text",
    labelName: "Price(Rs)",
    placeholder: "Enter price",
    isRequired: false,
    valueLabel: "price", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    inAdjust: false,
  },
  {
    type: "text",
    labelName: "Discount amount",
    placeholder: "Discount amount",
    isRequired: false,
    valueLabel: "discount_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    inAdjust: false,
  },

  {
    type: "select",
    labelName: "Discount Type",
    placeholder: "Discount Type",
    isRequired: false,
    repeatType: true, // only make true if there is more option button
    inAdjust: false,
    valueLabel: "discount_type", //to select correct value for field
    options: [
      { value: "flat", label: "Flat", type: "discount_type" },
      { value: "%", label: "%", type: "discount_type" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },

  {
    type: "date",
    labelName: "Effect From",
    placeholder: "Effect From",
    isRequired: false,
    valueLabel: "effect_from", //to select correct value for field
    // CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    inAdjust: false,
  },
  {
    type: "date",
    labelName: "Effect To",
    placeholder: "Effect To",
    isRequired: false,
    valueLabel: "effect_to", //to select correct value for field
    // CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    inAdjust: false,
  },
];

//production form option end

//mold form option start
export const FormOptionsMold = [
  //key-cartz
  {
    type: "text", //for input type
    labelName: "Name", // for input label
    placeholder: "Enter name", //for placeholder
    isRequired: false,
    valueLabel: "name", //to select correct value for field
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Product",
    placeholder: "Select product",
    isRequired: false,
    valueLabel: "product", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Status",
    placeholder: "Status",
    isRequired: false,
    valueLabel: "status", //to select correct value for field
    options: [
      { value: "active", label: "Active", type: "status" },
      { value: "deactive", label: "Deactive", type: "status" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//mold form option end

//cartoon stock form option start
export const FormOptionsCartoonStocks = [
  //key->cartstz
  {
    type: "date",
    labelName: "Purchase Data",
    placeholder: "Enter Purchase Date",
    isRequired: true,
    valueLabel: "purchase_date", //to select correct value for field
    // CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text",
    labelName: "Bill Number",
    placeholder: "Enter name",
    isRequired: true,
    valueLabel: "bill_number", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select vendor",
    isRequired: true,
    valueLabel: "vendor", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Cartoon Type",
    placeholder: "Select type",
    isRequired: true,
    valueLabel: "cartoon_type", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    repeatType: true, // only make true if there is more option button
    isAdjust: false,
  },
  {
    type: "number",
    labelName: "Quantity",
    placeholder: "Enter quantity",
    isRequired: true,
    valueLabel: "quantity", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    isAdjust: false,
  },

  {
    type: "number",
    labelName: "Price Per Cartoon",
    placeholder: "Enter Price Per Cartoon",
    isRequired: true,
    valueLabel: "price_per_cartoon", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    isAdjust: false,
  },
  {
    type: "number",
    labelName: "Paid Amount",
    placeholder: "Enter Paid Amount",
    isRequired: false,
    valueLabel: "paid_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Total Price",
    placeholder: "Enter total price",
    isRequired: true,
    valueLabel: "total_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//cartoon stock form option end

export const FormOptionsCartoonWithDraws = [
  {
    type: "select",
    labelName: "Product",
    placeholder: "Select product",
    isRequired: false,
    valueLabel: "product_id", //to select correct value for field
    labelStyle: "!inline-block",
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text",
    labelName: "Product Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "product_qty", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "text",
    labelName: "Cartoon Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "cartoon_qty", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "date",
    labelName: "Production Date",
    placeholder: "Enter Date",
    isRequired: false,
    valueLabel: "production_date", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "select",
    labelName: "Product Quality",
    placeholder: "Select quality",
    isRequired: false,
    valueLabel: "product_quality", //to select correct value for field
    labelStyle: "!inline-block",
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: true, // only make true if there is more option button
  },
];

//plastic stock form option start
export const FormOptionsPlasticStocks = [
  //key->plaststz
  {
    type: "date",
    labelName: "Purchase Data",
    placeholder: "Enter Purchase Date",
    isRequired: false,
    valueLabel: "purchase_date", //to select correct value for field
    // CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text",
    labelName: "Bill Number",
    placeholder: "Enter name",
    isRequired: false,
    valueLabel: "bill_number", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select vendor",
    isRequired: false,
    valueLabel: "vendor", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Plastic Type",
    placeholder: "Select type",
    isRequired: false,
    valueLabel: "plastic_type", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    repeatType: true, // only make true if there is more option button
    inAdjust: false,
  },
  {
    type: "text",
    labelName: "Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "quantity", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    inAdjust: false,
  },

  {
    type: "text",
    labelName: "Price Per Plastic",
    placeholder: "Enter Price Per Plastic",
    isRequired: false,
    valueLabel: "price_per_plastic", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    repeatType: true, // only make true if there is more option button
    isAdjust: false,
  },
  {
    type: "text",
    labelName: "Paid Amount",
    placeholder: "Enter Paid Amount",
    isRequired: false,
    valueLabel: "paid_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Total Price",
    placeholder: "Enter total price",
    isRequired: false,
    valueLabel: "total_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//plastic stock form option end

export const FormOptionsPlasticWithDraws = [
  {
    type: "select",
    labelName: "Product",
    placeholder: "Select product",
    isRequired: true,
    valueLabel: "product_id", //to select correct value for field
    labelStyle: "!inline-block",
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Product Quantity",
    placeholder: "Enter quantity",
    isRequired: true,
    valueLabel: "product_qty", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "text",
    labelName: "Plastic Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "plastic_qty", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "date",
    labelName: "Production Date",
    placeholder: "Enter Date",
    isRequired: false,
    valueLabel: "production_date", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: true, // only make true if there is more option button
  },
  {
    type: "select",
    labelName: "Product Quality",
    placeholder: "Select quality",
    isRequired: false,
    valueLabel: "product_quality", //to select correct value for field
    labelStyle: "!inline-block",
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: true, // only make true if there is more option button
  },
];

//leaf stock form option start
export const FormOptionsLeafStocks = [
  //key->leafstz
  {
    type: "date",
    labelName: "Purchase Data",
    placeholder: "Enter Purchase Date",
    isRequired: true,
    valueLabel: "purchase_date", //to select correct value for field
    // CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "text",
    labelName: "Bill Number",
    placeholder: "Enter name",
    isRequired: false,
    valueLabel: "bill_number", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select vendor",
    isRequired: true,
    valueLabel: "vendor", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "select",
    labelName: "Buy Method",
    placeholder: "Select Buy Method",
    isRequired: true,
    valueLabel: "buy_method", //to select correct value for field
    options: [
      { value: "direct_delivery", label: "Product1", type: "buy_method" },
      { value: "delivery_by_vendor", label: "Product2", type: "buy_method" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Leaf Type",
    placeholder: "Select type",
    isRequired: true,
    valueLabel: "leaf_store_ware_house", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Quantity",
    placeholder: "Enter quantity",
    isRequired: true,
    valueLabel: "quantity", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "number",
    labelName: "Price Per Leaf",
    placeholder: "Enter Price Per Leaf",
    isRequired: false,
    valueLabel: "total_cost_leaf", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "number",
    labelName: "Mileage",
    placeholder: "Enter mileage",
    isRequired: false,
    valueLabel: "mileage", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Distance Travel",
    placeholder: "Enter distance travel",
    isRequired: false,
    valueLabel: "distance_travel", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Hiring Cost",
    placeholder: "Enter hiring cost",
    isRequired: false,
    valueLabel: "hiring_cost", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Paid Amount",
    placeholder: "Enter Paid Amount",
    isRequired: false,
    valueLabel: "paid_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Overal Cost",
    placeholder: "Enter total price",
    isRequired: false,
    valueLabel: "total_cost_leaf_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//leaf stock form option end

//leaf stock form option start
export const FormOptionsStickerStocks = [
  //key->leafstz

  {
    type: "text",
    labelName: "Bill Number",
    placeholder: "Enter name",
    isRequired: true,
    valueLabel: "bill_number", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select vendor",
    isRequired: true,
    valueLabel: "vendor_id", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
    inAdjust: true, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "number",
    labelName: "Quantity",
    placeholder: "Enter quantity",
    isRequired: true,
    valueLabel: "quantity", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },

  {
    type: "number",
    labelName: "Paid Amount",
    placeholder: "Enter Paid Amount",
    isRequired: true,
    valueLabel: "paid_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
  {
    type: "number",
    labelName: "Total Amount",
    placeholder: "Enter total amount",
    isRequired: true,
    valueLabel: "total_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
    inAdjust: false, //used only when there is adjusted form, avoid for others
    repeatType: false,
  },
];

//leaf stock form option end
